'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _components = require('components');

var _support = require('helpers/support');

var _Question = require('./Question');

var _Question2 = _interopRequireDefault(_Question);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var questionData = [{
  question: 'Nền tảng thương mại điện tử (e commerce) và phần mềm quản lý là 2 phần khác nhau đúng không?',
  answer: '\n      <p>\u0110\xFAng, th\xF4ng th\u01B0\u1EDDng shop s\u1EBD d\xF9ng:</p>\n      <ul>\n      <li>Ph\u1EA7n m\u1EC1m: \u0111\u1EC3 qu\u1EA3n l\xFD v\u1EADn h\xE0nh hi\u1EC7u qu\u1EA3 (doanh thu, l\u1ECBch h\u1EB9n, nh\xE2n vi\xEAn\u2026) v\xE0 ch\u0103m s\xF3c kh\xE1ch h\xE0ng c\u0169.</li>\n      <li>N\u1EC1n t\u1EA3ng: \u0111\u1EC3 th\xEAm kh\xE1ch h\xE0ng m\u1EDBi v\xE0 qu\u1EA3ng b\xE1 h\xECnh \u1EA3nh cho shop: b\u1EA1n \u0111\u01B0\u1EE3c t\u1EA1o 1 c\u1EEDa h\xE0ng tr\u1EF1c tuy\u1EBFn tr\xEAn n\u1EC1n t\u1EA3ng Lookme.vn \u0111\u1EC3 thu h\xFAt kh\xE1ch h\xE0ng m\u1EDBi.</li>\n      </ul>\n      <p>Lookme t\xEDch h\u1EE3p 2 c\xF4ng c\u1EE5 \u0111\u1EC3 gi\xFAp shop qu\u1EA3n l\xFD d\u1EC5 d\xE0ng h\u01A1n v\xE0 t\u0103ng doanh thu.</p>\n      '
}, {
  question: 'Dữ liệu có an toàn khi dùng gói tích hợp của Lookme?',
  answer: '<p>B\u1EA1n ho\xE0n to\xE0n c\xF3 th\u1EC3 y\xEAn t\xE2m v\u1EC1 to\xE0n b\u1ED9 d\u1EEF li\u1EC7u s\u1EBD \u0111\u01B0\u1EE3c b\u1EA3o l\u01B0u an to\xE0n trong h\u1EC7 th\u1ED1ng b\u1EA3o m\u1EADt c\u1EE7a Lookme, th\xF4ng qua c\xE1c \u0111i\u1EC1u kho\u1EA3n b\u1EA3o m\u1EADt v\xE0 c\u1EA1nh tranh l\xE0nh m\u1EA1nh \u0111\u01B0\u1EE3c k\xFD k\u1EBFt gi\u1EEFa Lookme v\xE0 b\u1EA1n.</p>'
}, {
  question: 'Tôi có cần phải cài đặt phần mềm vào máy tính không?',
  answer: '<p>Kh\xF4ng. Ph\u1EA7n m\u1EC1m Lookme \u0111\u01B0\u1EE3c ph\xE1t tri\u1EC3n d\u1EF1a tr\xEAn c\xF4ng ngh\u1EC7 \u0111\xE1m m\xE2y, s\u1EED d\u1EE5ng ho\xE0n to\xE0n tr\xEAn Internet. B\u1EA1n c\xF3 th\u1EC3 qu\u1EA3n l\xFD d\xF9 b\u1EA1n \u1EDF b\u1EA5t k\u1EF3 \u0111\xE2u, b\u1EA1n ch\u1EC9 c\u1EA7n s\u1EED d\u1EE5ng tr\xECnh duy\u1EC7t tr\xEAn m\xE1y t\xEDnh (tr\xECnh duy\u1EC7t Google Chrome ho\u1EB7c Firefox)</p>'
}, {
  question: 'Tôi phải trả phí như thế nào?',
  answer: '\n        <p>Ph\u1EA7n m\u1EC1m: b\u1EA1n \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng mi\u1EC5n ph\xED 7 ng\xE0y tr\u01B0\u1EDBc khi quy\u1EBFt \u0111\u1ECBnh s\u1EED d\u1EE5ng theo g\xF3i \u0111\u01B0\u1EE3c tr\xECnh b\xE0y trong ph\u1EA7n b\u1EA3ng gi\xE1.</p>\n        <p>N\u1EC1n t\u1EA3ng: b\u1EA1n \u0111\u01B0\u1EE3c t\u1EA1o 1 c\u1EEDa h\xE0ng tr\u1EF1c tuy\u1EBFn \u0111\u1EC3 thu h\xFAt kh\xE1ch h\xE0ng m\u1EDBi. M\u1ED7i kh\xE1ch h\xE0ng m\u1EDBi t\u1EEB n\u1EC1n t\u1EA3ng Lookme th\xEC b\u1EA1n s\u1EBD tr\u1EA3 ph\xED hoa h\u1ED3ng 35%.</p>\n        <p>* Kh\xE1ch h\xE0ng m\u1EDBi \u0111\u01B0\u1EE3c t\xEDnh l\xE0 kh\xE1ch h\xE0ng ch\u01B0a c\xF3 trong h\u1EC7 th\u1ED1ng d\u1EEF li\u1EC7u c\u1EE7a shop ho\u1EB7c kh\xF4ng c\xF3 b\u1EA5t k\u1EF3 giao d\u1ECBch n\xE0o t\u1EA1i shop trong v\xF2ng 12 th\xE1ng.</p>\n        <p>Lookme s\u1EBD \u0111\u1EA7u t\u01B0 nh\u1EEFng chi\u1EBFn d\u1ECBch marketing ph\xF9 h\u1EE3p \u0111\u1EC3 thu h\xFAt kh\xE1ch h\xE0ng ti\u1EC1m n\u0103ng cho b\u1EA1n. Lookme c\u0169ng cung c\u1EA5p nh\u1EEFng c\xF4ng c\u1EE5 gi\xFAp b\u1EA1n t\u01B0\u01A1ng t\xE1c v\u1EDBi kh\xE1ch h\xE0ng ch\u1EE7 \u0111\u1ED9ng h\u01A1n: chat online, gi\u1EA3m gi\xE1 theo khung gi\u1EDD... </p>\n        '
}, {
  question: 'Tôi có được hướng dẫn khi đăng ký sử dụng?',
  answer: '<p>Lookme s\u1EBD g\u1EEDi th\xF4ng tin h\u01B0\u1EDBng d\u1EABn \u0111\u1EA7y \u0111\u1EE7 v\xE0 \u0111\u1ED9i ng\u0169 h\u1ED7 tr\u1EE3 cho b\u1EA1n, gi\xFAp b\u1EA1n t\u1EADn d\u1EE5ng t\u1ED1i \u0111a t\u1EEB c\xF4ng c\u1EE5 c\u1EE7a Lookme</p>\n        <p>Ho\u1EB7c b\u1EA1n c\xF3 th\u1EC3 li\xEAn l\u1EA1c hotline c\u1EE7a Lookme: 0933 207 298 ho\u1EB7c contact@lookme.vn</p>\n        '
}];

var PricingPlans = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PricingPlans, _Component);

  function PricingPlans(props) {
    (0, _classCallCheck3.default)(this, PricingPlans);

    var _this = (0, _possibleConstructorReturn3.default)(this, (PricingPlans.__proto__ || (0, _getPrototypeOf2.default)(PricingPlans)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(PricingPlans, [{
    key: 'render',
    value: function render() {
      var costBasic = 240000;
      var costStandard = 270000;
      var costPremium = 450000;
      var promotion12 = 0.85; // giảm 15 %
      var promotion24 = 0.75; // giảm 25%
      var styles = require('./PricingPlans.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.mainView },
        _react2.default.createElement(
          'div',
          { className: styles.minimalBackground },
          _react2.default.createElement(
            'div',
            { className: styles.intro },
            _react2.default.createElement(
              'h2',
              null,
              'T\u0102NG KH\xC1CH H\xC0NG M\u1EDAI & QU\u1EA2N L\xDD D\u1EC4 D\xC0NG CHO SPA/SALON'
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.container + ' container' },
          _react2.default.createElement(_components.HelmetSEO, { path: 'uu-dai' }),
          _react2.default.createElement(
            'div',
            { className: styles.tableView },
            _react2.default.createElement(
              'table',
              { className: styles.table },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement('th', null),
                  _react2.default.createElement('th', null),
                  _react2.default.createElement(
                    'th',
                    { className: styles.BGBasic },
                    'Basic'
                  ),
                  _react2.default.createElement(
                    'th',
                    { className: styles.BGStandard },
                    'Plus'
                  ),
                  _react2.default.createElement(
                    'th',
                    { className: styles.BGPremium },
                    'Premium'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement('th', null),
                  _react2.default.createElement(
                    'th',
                    null,
                    'Gi\xE1 \u01B0u \u0111\xE3i'
                  ),
                  _react2.default.createElement(
                    'th',
                    { className: styles.basic },
                    _support.Helper.formatMoney(costBasic)
                  ),
                  _react2.default.createElement(
                    'th',
                    { className: styles.standard },
                    _support.Helper.formatMoney(costStandard)
                  ),
                  _react2.default.createElement(
                    'th',
                    { className: styles.premium },
                    _support.Helper.formatMoney(costPremium)
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Ph\u1EA7n m\u1EC1m qu\u1EA3n l\xFD'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'ul',
                      null,
                      _react2.default.createElement(
                        'li',
                        null,
                        'Qu\u1EA3n l\xFD salon (ERP) Desktop'
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        'Qu\u1EA3n l\xFD salon (ERP) Mobile'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'ul',
                      null,
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-check ' + styles.check })
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-check ' + styles.check })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'ul',
                      null,
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-check ' + styles.check })
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-check ' + styles.check })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'ul',
                      null,
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-check ' + styles.check })
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-check ' + styles.check })
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Ch\u0103m s\xF3c kh\xE1ch h\xE0ng'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'ul',
                      null,
                      _react2.default.createElement(
                        'li',
                        null,
                        'Chat t\u01B0 v\u1EA5n kh\xE1ch h\xE0ng'
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        'T\u1ED5ng \u0111\xE0i ch\u0103m s\xF3c'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'ul',
                      null,
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-check ' + styles.check })
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-close ' + styles.close })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'ul',
                      null,
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-check ' + styles.check })
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-close ' + styles.close })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'ul',
                      null,
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-check ' + styles.check })
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-check ' + styles.check })
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Gi\u1EA3i ph\xE1p marketing ti\u1EBFp c\u1EADn KH m\u1EDBi'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'ul',
                      null,
                      _react2.default.createElement(
                        'li',
                        null,
                        'Ti\u1EBFp c\u1EADn kh\xE1ch h\xE0ng m\u1EDBi qua s\xE0n Lookme.vn'
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        'Shop ri\xEAng tr\xEAn Lookme.vn k\xEDch ho\u1EA1t \u0111\u1EB7t l\u1ECBch'
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        'Banner qu\u1EA3ng c\xE1o tr\xEAn Lookme.vn'
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        'B\xE0i review tr\xEAn Facebook Lookme'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'ul',
                      null,
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-close ' + styles.close })
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-check ' + styles.check })
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-close ' + styles.close })
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-close ' + styles.close })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'ul',
                      null,
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-check ' + styles.check })
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-check ' + styles.check })
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-close ' + styles.close })
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-close ' + styles.close })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'ul',
                      null,
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-check ' + styles.check })
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-check ' + styles.check })
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-check ' + styles.check })
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        _react2.default.createElement('i', { className: 'fa fa-check ' + styles.check })
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement('td', null),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'ul',
                      null,
                      _react2.default.createElement(
                        'li',
                        null,
                        'S\u1ED1 l\u01B0\u1EE3ng chi nh\xE1nh'
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        'S\u1ED1 l\u01B0\u1EE3ng t\xE0i kho\u1EA3n qu\u1EA3n l\xFD'
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        'S\u1ED1 l\u01B0\u1EE3ng nh\xE2n vi\xEAn'
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        'S\u1ED1 l\u01B0\u1EE3ng s\u1EA3n ph\u1EA9m/d\u1ECBch v\u1EE5'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'ul',
                      null,
                      _react2.default.createElement(
                        'li',
                        null,
                        '1(*)'
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        '5'
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        '10'
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        '500'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'ul',
                      null,
                      _react2.default.createElement(
                        'li',
                        null,
                        '2 (*)'
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        '10'
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        '20'
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        'Kh\xF4ng gi\u1EDBi h\u1EA1n'
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    _react2.default.createElement(
                      'ul',
                      null,
                      _react2.default.createElement(
                        'li',
                        null,
                        '4 (*)'
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        'Kh\xF4ng gi\u1EDBi h\u1EA1n'
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        'Kh\xF4ng gi\u1EDBi h\u1EA1n'
                      ),
                      _react2.default.createElement(
                        'li',
                        null,
                        'Kh\xF4ng gi\u1EDBi h\u1EA1n'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  { className: styles.noneRightBottomLeft },
                  _react2.default.createElement('td', null),
                  _react2.default.createElement(
                    'td',
                    {
                      colSpan: '4',
                      className: styles.note,
                      style: { paddingBottom: '5px' }
                    },
                    '* Ph\xED hoa h\xF4ng tr\xEAn 1 kh\xE1ch h\xE0ng m\u1EDBi l\xE0 35%.'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  { className: styles.noneBorder },
                  _react2.default.createElement('td', null),
                  _react2.default.createElement(
                    'td',
                    {
                      colSpan: '4',
                      className: styles.note,
                      style: { paddingTop: '5px', paddingBottom: '5px' }
                    },
                    '(*) M\u1ED7i chi nh\xE1nh t\u0103ng th\xEAm 200k. Salon tr\xEAn 5 chi nh\xE1nh, vui l\xF2ng li\xEAn h\u1EC7 Lookme.'
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  { className: styles.noneBorder },
                  _react2.default.createElement('td', null),
                  _react2.default.createElement(
                    'td',
                    {
                      colSpan: '4',
                      className: styles.note,
                      style: { paddingTop: '5px' }
                    },
                    '* Gi\xE1 tr\xEAn ch\u1EC9 \xE1p d\u1EE5ng cho g\xF3i mua 6 th\xE1ng.'
                  )
                )
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/dang-ki-doi-tac', className: styles.btnRegisterPartner },
              '\u0110\u0102NG K\xDD'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.questionView },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              'C\xC2U H\u1ECEI TH\u01AF\u1EDCNG G\u1EB6P'
            ),
            questionData.map(function (item) {
              return _react2.default.createElement(_Question2.default, (0, _extends3.default)({}, item));
            })
          )
        )
      );
    }
  }]);
  return PricingPlans;
}(_react.Component), _class.propTypes = {}, _temp);
exports.default = PricingPlans;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/PricingPlans/index.js
// module id = 1686
// module chunks = 0